export default function($) {
  $('.cssAnimate').waypoint(function (direction) {
    if ($(this.element).hasClass('js-intro-left-img')) {
      $(this.element).addClass('animate-in slide-in-from-bottom-12 fade-in duration-1000').removeClass('cssAnimate');
    }
    if ($(this.element).hasClass('js-intro-surtitle')) {
      $(this.element).addClass('animate-in slide-in-from-bottom-12 fade-in duration-1500').removeClass('cssAnimate');
    }
    if ($(this.element).hasClass('js-intro-title')) {
      $(this.element).addClass('animate-in slide-in-from-bottom-12 fade-in duration-1500').removeClass('cssAnimate');
    }
    if ($(this.element).hasClass('js-intro-text')) {
      $(this.element).addClass('animate-in slide-in-from-bottom-12 fade-in duration-1500').removeClass('cssAnimate');
    }
    if ($(this.element).hasClass('js-intro-button')) {
      $(this.element).addClass('animate-in slide-in-from-bottom-12 fade-in duration-1500').removeClass('cssAnimate');
    }
    if ($(this.element).hasClass('js-intro-right-img')) {
      $(this.element).addClass('animate-in slide-in-from-bottom-12 fade-in duration-2000').removeClass('cssAnimate');
    }

  },{ offset: '80%' });

  $('.introduction-images').each(function() {
    var $introImages = $(this);
    var $keyFactsWrapper = $introImages.find('.key-facts-wrapper');

    if ($keyFactsWrapper.length > 0) {
      $keyFactsWrapper.find('.key-fact').addClass('cssAnimate');
      $('.cssAnimate').waypoint(function (direction) {
        if ($(this.element).hasClass('key-fact')) {
          $(this.element).addClass('animate-in slide-in-from-bottom-12 fade-in duration-1000').removeClass('cssAnimate');
        }
      },{ offset: '80%' });
    }
  })
}
